import { ComponentType } from '../../registries/types/propTypes';
import {
  type default as StandardBannerNoCTAProps,
  type Images,
} from '../../../components/StandardBannerNoCTA/types/propsTypes';
import { CMSTransformerDataType } from '../../types/common';
const transformStandardBannerNoCTA = (data: CMSTransformerDataType): StandardBannerNoCTAProps => {
  const standardBanner = Array.isArray(data?.standard_banner_no_cta)
    ? data?.standard_banner_no_cta[0]
    : data?.standard_banner_no_cta;
  const images: Images[] = standardBanner?.images?.map((item: CMSTransformerDataType) => {
    const image = {
      redirectionInfo: {
        target: item.link.target,
        url: item.link.url,
      },
      imageList: item?.image?.images?.map((image: CMSTransformerDataType) => ({
        url: image.image.url,
        altText: image.alt_text,
        viewport: image.viewport,
      })),
    };
    return image;
  });
  return {
    componentType: ComponentType.standard_banner_no_cta,
    images,
  };
};

export default transformStandardBannerNoCTA;
